import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Button,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
} from "@material-ui/core";
import LoadingFullView from "./LoadingFullView.js";
import API from "../Services/API";
import './GroupTherapyProcess.css';
import './RegistrationModal.css';
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from '@material-ui/icons/Clear';
import RegistrationModal from './RegistrationModal';
import zIndex from "@material-ui/core/styles/zIndex.js";
import { AlarmRounded } from "@material-ui/icons";

const api = API.create();

const GroupTherapyProcess = (props) => {
  const { accountId } = useParams();
  const params = props.match.params;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const testRef1 = useRef(null); // Create a reference for the target element
  const testRef = useRef(null); // Create a reference for the target element
  const [sessions, setSessions] = useState([]);
  const [sessionsMn, setSessionsMn] = useState([]);
  const [groupids, setGroupids] = useState([]);
  const [visibleSessions, setVisibleSessions] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [selectedFilters, setSelectedFilters] = useState([]); // Dynamically set later
  const [openDialog, setOpenDialog] = useState(false);
  const [tableContainerHeight, setTableContainerHeight] = useState('calc(100vh - 180px)');
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [sessionTime, setSessionTime] = useState("");
  const [supervisor, setSupervisor] = useState("");
  const staticHeadingHeight = 60;
  const [openSearchDialog, setOpenSearchDialog] = useState(false);
  const [rowHeight, setRowHeight] = useState(48); // Default value
  const rowRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [sessionDateValue, setSessionDateValue] = useState('');
  const [addToGroup, setAddToGroup] = useState('');
  const [lateReason, setLateReason] = useState('');
  const [absentStatus, setAbsentStatus] = useState('');
  const [groupId, setGroupId] = useState(null);
  const [elementTop, setElementTop] = useState(120);
  const [accName, setAccName] = useState(' ');
  const [calculatedTop, setCalculatedTop] = useState(0); // State to hold the top position plus 90
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    dob: '',
    phone: '',
    gender: '',
    verificationMethod: ''
  });

  const useDeviceType = () => {
    const [isMobile, setIsMobile] = useState(false);

    const checkDeviceType = () => {
      if (window.innerWidth < 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    useEffect(() => {
      // Run on component mount
      checkDeviceType();

      // Add a listener to detect window resize
      window.addEventListener('resize', checkDeviceType);

      // Cleanup the listener when component unmounts
      return () => {
        window.removeEventListener('resize', checkDeviceType);
      };
    }, []);

    return isMobile;
  };
  const isMobile = useDeviceType();
  const handleOpenSearchDialog = () => {
    setOpenSearchDialog(true);
  };


  const handleCloseSearchDialog = () => {
    setOpenSearchDialog(false);
  };
  // Static heading height for fallback calculations
  useEffect(() => {
    setTimeout(() => {
      if (document.getElementById("testnew")) {
        document.getElementById("testnew").top = calculatedTop;
      }
    }, 1000);
  }, [calculatedTop]);

  // Dynamically adjust table height and rows per page
  useEffect(() => {
    const updateTableHeight = () => {
      const tableContainer = document.querySelector('.table-container');
      const topOffset = tableContainer ? tableContainer.getBoundingClientRect().top : staticHeadingHeight;

      const height = window.innerHeight - topOffset - 135; // Adjust this padding based on your design
      setTableContainerHeight(`${height}px`);

      const estimatedRowHeight = rowHeight;
      const calculatedRowsPerPage = Math.floor((height - (!isMobile ? 57 : 112)) / estimatedRowHeight);

      // Log for debugging purposes
      console.log('Rows per page calculated:', calculatedRowsPerPage);

      // Only update if it has changed
      if (calculatedRowsPerPage !== rowsPerPage) {
        setRowsPerPage(calculatedRowsPerPage);
      }
    };

    // Initially call it
    updateTableHeight();

    // Update height on window resize
    window.addEventListener('resize', updateTableHeight);

    // Clean up event listener
    return () => {
      window.removeEventListener('resize', updateTableHeight);
    };
  }, [rowsPerPage]);

  useEffect(() => {
    setVisibleSessions(sessions.slice(page * rowsPerPage, (page + 1) * rowsPerPage));
  }, [sessions, rowsPerPage, page]);

  // Recalculate visible sessions when rowsPerPage or sessions change
  useEffect(() => {
    console.log('Sessions or rows per page updated');
    setVisibleSessions(sessions.slice(0, rowsPerPage));
    setPage(0); // Reset to page 0 when rowsPerPage changes
  }, [rowsPerPage, sessions]);
  useEffect(() => {
    const filteredSessions = applyFilter(sessionsMn); // Apply filter on existing sessions
    setSessions(filteredSessions); // Update the session data
  }, [selectedFilters]);
  useEffect(() => {
    setLoading(true);
    api.getGroupTheropyValues(
      {
        dbname: params.accountId,
      },
      (providerRes) => {
        if (providerRes.status === 200) {
          const providerResObj = providerRes.data;
          const fetchedSessions = providerResObj["therapy sessions"] || [];
          const fetchedGroups = providerResObj["therapy groups"] || [];
          const accName = providerResObj["accountName"] || ' ';
          setAccName(accName);
          setGroupids(fetchedGroups);
          setSessionsMn(fetchedSessions);
          const filteredSessions = applyFilter(fetchedSessions); // Apply filter on fetched data
          setSessions(filteredSessions); // Update state with filtered data
          setLoading(false);

        } else {
          setError("Failed to fetch data. Please try again.");
          setLoading(false);
        }
      }
    );
  }, [accountId, params.accountId]);
  const handleRemoveFilter = (index) => {
    console.log(selectedFilters + "  " + index);
    const newFilters = selectedFilters.filter((_, i) => i !== index);
    const filterToRemove = selectedFilters[index];
    console.log(filterToRemove + " ind  " + index + " len " + selectedFilters.length);
    if (filterToRemove.startsWith("Start Date")) {
      setStartDate('');
    } else if (filterToRemove.startsWith("End Date")) {
      setEndDate('');
    } else if (filterToRemove.startsWith("Group")) {
      setSelectedGroup('');
      setSelectedGroupName('');
    }
    setSelectedFilters(newFilters);
  };
  const applyFilter = (data) => {
    let filteredData = [...data];
    console.log("Original Data:", filteredData);

    selectedFilters.forEach(filter => {
      if (filter.startsWith("Start Date:")) {
        console.log("Start Date filter detected");
        const dateString = filter.split(": ")[1];
        const date = new Date(dateString.replace(/-/g, "/")); // Convert "YYYY-MM-DD" to "YYYY/MM/DD" for Date parsing
        console.log("Parsed Start Date:", date);

        filteredData = filteredData.filter(session => {
          const sessionDate = new Date(session.sessionDateValue); // Parses "MM/DD/YYYY" format correctly
          console.log(`Session Date: ${sessionDate}, Start Date: ${date}`);
          return sessionDate >= date;
        });
        console.log("Data after Start Date filter:", filteredData);
      }
      else if (filter.startsWith("End Date:")) {
        console.log("End Date filter detected");
        const dateString = filter.split(": ")[1];
        const date = new Date(dateString.replace(/-/g, "/")); // Convert "YYYY-MM-DD" to "YYYY/MM/DD"
        console.log("Parsed End Date:", date);

        filteredData = filteredData.filter(session => {
          const sessionDate = new Date(session.sessionDateValue); // Parses "MM/DD/YYYY" format correctly
          console.log(`Session Date: ${sessionDate}, End Date: ${date}`);
          return sessionDate <= date;
        });
        console.log("Data after End Date filter:", filteredData);
      }
      else if (filter.startsWith("Group Name:")) {
        console.log("Group Name filter detected with Group:", selectedGroup);

        filteredData = filteredData.filter(session => session.groupId == selectedGroup);
        console.log("Data after Group Name filter:", filteredData);
      }
    });

    console.log("Filtered Data:", filteredData);
    return filteredData;
  };

  const handleNextPage = () => {
    if ((page + 1) * rowsPerPage < sessions.length) {
      setPage(page + 1);
    } else {
      setError("No more sessions to display.");
    }
  };
  const handlePreviousPage = () => {
    if (page === 0) {
      setError("No previous page");
      return; // Prevent further action
    }
    if (page > 0) {
      setPage(page - 1);
    }
  };
  const handleRegisterClick = (session) => {
    const { groupId, sessionId, sessionDateValue } = session;

    // Set the values based on the session
    setGroupId(session.groupId); // Assuming setGroupId is a state setter
    setSessionId(session.sessionId);
    setSessionDateValue(session.sessionDateValue + " " + session.sessionStartTime);
    setAddToGroup(session.addToGroup); // or false depending on the logic
    setLateReason(session.lateReason);   // You can collect this from a form or input field
    setAbsentStatus(session.absentStatus); // or true based on logic

    // Open the modal
    setModalOpen(true);
  };
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (testRef.current) {
        const rect = testRef.current.getBoundingClientRect();
        const topPosition = rect.top;
        setCalculatedTop(topPosition + 90);
        console.log(topPosition + 90);
      }
    });

    if (testRef.current) {
      observer.observe(testRef.current);
    }

    return () => {
      if (testRef.current) {
        observer.unobserve(testRef.current);
      }
    };
  }, [sessions]);
  const handleSearch = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    const filters = [];
    if (startDate) filters.push(`Start Date: ${startDate}`);
    if (endDate) filters.push(`End Date: ${endDate}`);
    if (selectedGroupName) {
      filters.push(`Group Name: ${selectedGroupName}`);
    }
    setSelectedFilters(filters);
    console.log(filters); // For debugging
    handleCloseSearchDialog();
  };


  const handleCloseSnackbar = () => {
    setError(null);
  };

  useEffect(() => {
    console.log("useEffect called");
    setTimeout(() => {
      if (testRef.current) {
        const rect = testRef.current.getBoundingClientRect();
        const topPosition = rect.top;
        setCalculatedTop(topPosition + 90);
        console.log("Calculated Top Position:", topPosition + 90);
      } else {
        console.log("Ref is still null");
      }
    }, 1); // 100ms delay
  }, [sessions]);
  useEffect(() => {
    console.log("useEffect called");
    setTimeout(() => {
      if (testRef1.current) {
        const rect = testRef1.current.getBoundingClientRect();
        setElementTop(calculatedTop + 3.5);
      } else {
        console.log("Ref is still null");
      }
    }, 1); // 100ms delay
  }, [calculatedTop]);
  if (loading) {
    return <LoadingFullView />;
  }

  return (
    <div style={{
      padding: '20px',
      paddingBottom: '0px',
      paddingTop: '0px',
      background: !isMobile ? 'linear-gradient(135deg, rgba(77, 182, 172, 0.9), rgba(129, 199, 132, 0.9))' : 'linear-gradient(135deg, #37AFE1, #77CDFF)', // Lighter green gradient
      height: '100%', // Ensure it covers the full viewport height
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center' // Center the content
    }}>
      <div style={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        <Typography style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '5px' }}>
          {accName}
        </Typography>
      </div>
      <div id="test" ref={testRef} className="heading-container" style={{
        height: `${staticHeadingHeight}px`,
        textAlign: 'center',
        marginTop: '15px',
        color: '#fff', // White text for better contrast
        padding: '15px 20px', // Add some padding for spacing
        borderRadius: '8px', // Rounded corners for a softer look
        width: (!isMobile ? 'auto' : '90%'),
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        alignContent: (!isMobile ? '' : 'center'),
        background: !isMobile ? '#004d40' : '#10375C'// Subtle shadow for depth
      }}>
        <Typography variant="h4" className="heading" style={{ fontWeight: 'bold', fontSize: !isMobile ? '2rem' : '28px' }}>
          Group Therapy
        </Typography>
        {true && (
          <Typography variant="subtitle1" className="subheading" style={{ fontSize: !isMobile ? '1.2rem' : '13px', opacity: '0.9' }}>
            View & register for upcoming therapy sessions
          </Typography>
        )}

      </div>
      <div id="testnew" ref={testRef1} style={{
        display: 'flex',
        alignItems: 'center',
        position: 'fixed',
        border: '2px solid #1976D2',
        borderRadius: '25px',
        padding: (!isMobile ? '0px 16px' : '0px 0px'),
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#f5f5f5',
        zIndex: isModalOpen || openSearchDialog ? 0 : 1000,
        right: '1px',
        marginRight: '14px',
        maxWidth: '92%',
        top: `${elementTop}px`
      }}>
        <IconButton onClick={handleOpenSearchDialog} style={{ marginRight: (!isMobile ? '10px' : '0px'), padding: '8px', marginLeft: (!isMobile ? '0px' : '6px') }}>
          <SearchIcon />
        </IconButton>

        <Typography style={{ fontWeight: 'bold', color: '#1976D2', marginRight: '8px', fontSize: '18px' }}>
          {!isMobile ? 'Search Sessions' : ''}
        </Typography>

        {selectedFilters.length > 0 && !isMobile ? (
          // Desktop view: Full badges
          <div style={{ display: 'flex', marginRight: '10px' }}>
            {selectedFilters.map((filter, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: 'rgb(227, 227, 227)',
                  padding: '0px 5px',
                  borderRadius: '100px',
                  marginRight: '5px',
                  marginTop: '4px',
                  marginBottom: '4px',
                  whiteSpace: 'nowrap',
                }}
              >
                <Typography variant="body2" style={{ color: '#444343', fontWeight: 'bold' }}>
                  {filter}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => handleRemoveFilter(index)}
                  style={{ marginLeft: '5px' }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </div>
            ))}
          </div>
        ) : (
          // Mobile view: Ellipsis with always-visible close button
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', overflow: 'hidden' }}>
            {selectedFilters.map((filter, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: 'rgb(227, 227, 227)',
                  padding: '0px 5px',
                  borderRadius: '100px',
                  marginRight: '5px',
                  marginTop: '4px',
                  marginBottom: '4px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden', // Hide overflow
                  textOverflow: 'ellipsis', // Ellipses for overflow
                  maxWidth: '100px' // Adjust width for mobile
                }}
              >
                <Typography variant="body2" style={{
                  color: '#444343',
                  fontWeight: 'bold',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}>
                  {filter}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => handleRemoveFilter(index)}
                  style={{ marginLeft: '5px' }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </div>
            ))}
          </div>
        )}
      </div>

      {
        isMobile ? (
          <div className="grid-container" style={{ borderRadius: '8px', marginTop: !isMobile ? '56px' : '56px', overflowX: 'hidden' }}>
            {/* Check if sessions array is empty */}
            {sessions.length === 0 ? (
              <div className="no-data-notification">
                <Typography variant="h6">No sessions available at this criteria.</Typography>
                <Typography variant="body1">Please change criteria or check back later!</Typography>
              </div>
            ) : (
              // Group sessions by groupName
              sessions.map((session) => (
                <div key={session.sessionId} className="session-card highlighted"> {/* Added 'highlighted' class */}
                  <div className="group-name-header">{session.groupName}</div> {/* Group name header inside the session card */}
                  <Typography variant="h6" className="session-title">
                    {session.sessionTopic}
                  </Typography>
                  <Typography variant="body1" className="session-info">Date: {session.sessionDateValue}</Typography>
                  <Typography variant="body1" className="session-info">Time: {session.sessionStartTime}</Typography>
                  <Typography variant="body1" className="session-info">Supervisor: {session.sessionSupervisorName}</Typography>
                  <Typography variant="body1" className="session-info">Leader: {session.sessionLeaderName}</Typography>
                  <button className="register-button-new" onClick={() => handleRegisterClick(session)}>
                    Register
                  </button>
                </div>
              ))
            )}
          </div>
        ) : (
          <TableContainer
            style={{
              marginTop: '56px',
              height: tableContainerHeight,
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
              overflowY: 'hidden'
            }}
            className="table-container"
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow className="table-header" style={{ background: 'rgb(10, 62, 123)', color: '#fff', zIndex: isModalOpen || openSearchDialog ? 0 : 2 }}>
                  <TableCell padding="default" style={{ fontWeight: 'bold', color: 'white', backgroundColor: 'rgb(10, 62, 123)' }}>Group Name</TableCell>
                  <TableCell padding="default" style={{ fontWeight: 'bold', color: 'white', backgroundColor: 'rgb(10, 62, 123)' }}>Session Topic</TableCell>
                  <TableCell padding="default" style={{ fontWeight: 'bold', color: 'white', backgroundColor: 'rgb(10, 62, 123)' }}>Session Date</TableCell>
                  <TableCell padding="default" style={{ fontWeight: 'bold', color: 'white', backgroundColor: 'rgb(10, 62, 123)' }}>Start Time</TableCell>
                  <TableCell padding="default" style={{ fontWeight: 'bold', color: 'white', backgroundColor: 'rgb(10, 62, 123)' }}>Supervisor Name</TableCell>
                  <TableCell padding="default" style={{ fontWeight: 'bold', color: 'white', backgroundColor: 'rgb(10, 62, 123)' }}>Leader Name</TableCell>
                  <TableCell padding="default" style={{ fontWeight: 'bold', color: 'white', backgroundColor: 'rgb(10, 62, 123)' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="table-body" style={{ overflow: 'hidden' }}>
                {visibleSessions.map((session) => (
                  <TableRow ref={rowRef} key={session.sessionId} style={{ position: 'relative', animation: 'fadeIn 0.5s' }}>
                    <TableCell style={{ paddingTop: '5px', paddingBottom: '5px' }}>{session.groupName}</TableCell>
                    <TableCell style={{ paddingTop: '5px', paddingBottom: '5px' }}>{session.sessionTopic}</TableCell>
                    <TableCell style={{ paddingTop: '5px', paddingBottom: '5px' }}>{session.sessionDateValue}</TableCell>
                    <TableCell style={{ paddingTop: '5px', paddingBottom: '5px' }}>{session.sessionStartTime}</TableCell>
                    <TableCell style={{ paddingTop: '5px', paddingBottom: '5px' }}>{session.sessionSupervisorName}</TableCell>
                    <TableCell style={{ paddingTop: '5px', paddingBottom: '5px' }}>{session.sessionLeaderName}</TableCell>
                    <TableCell style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                      <button className="register-button" onClick={() => handleRegisterClick(session)}>
                        Register
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
      }
      {!isMobile && visibleSessions.length < sessions.length && (
        <div
          className="pagination-buttons"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginBottom: isMobile ? '0px' : '5px'
          }}
        >
          {/* Previous Button */}
          <button
            type="button"
            title="Previous"
            onClick={handlePreviousPage}
            disabled={page === 0}
            style={{
              border: 'none',
              backgroundColor: 'transparent', // Transparent background to blend with the page
              cursor: page === 0 ? 'not-allowed' : 'pointer',
              padding: '10px',
              width: '40px',
              height: '40px',
              marginRight: '25px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {/* CSS Arrow Icon for Back */}
            <div
              style={{
                border: 'solid white',
                borderWidth: '0 4px 4px 0',
                display: 'inline-block',
                padding: '7px',
                transform: 'rotate(135deg)',
                WebkitTransform: 'rotate(135deg)',
                color: 'white', // Arrow color in white
                opacity: page === 0 ? 0.3 : 1, // Lighter when disabled
              }}
            />
          </button>

          {/* Page Number Display */}
          <div style={{ fontWeight: 'bold', fontSize: '18px', color: 'rgba(10, 10, 10, 0.8)' }}>
            Page {page + 1} of {Math.ceil(sessions.length / rowsPerPage)}
          </div>

          {/* Next Button */}
          <button
            type="button"
            title="Next"
            onClick={handleNextPage}
            disabled={(page + 1) * rowsPerPage >= sessions.length}
            style={{
              border: 'none',
              backgroundColor: 'transparent', // Transparent background to blend with the page
              cursor: (page + 1) * rowsPerPage >= sessions.length ? 'not-allowed' : 'pointer',
              padding: '10px',
              width: '40px',
              height: '40px',
              display: 'flex',
              justifyContent: 'center',
              marginLeft: '25px',
              alignItems: 'center',
            }}
          >
            {/* CSS Arrow Icon for Forward */}
            <div
              style={{
                border: 'solid white',
                borderWidth: '0 4px 4px 0',
                display: 'inline-block',
                padding: '7px',
                transform: 'rotate(-45deg)',
                WebkitTransform: 'rotate(-45deg)',
                color: 'white', // Arrow color in white
                opacity: (page + 1) * rowsPerPage >= sessions.length ? 0.3 : 1, // Lighter when disabled
              }}
            />
          </button>
        </div>
      )}


      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={!!error} onClose={handleCloseSnackbar} message={error} autoHideDuration={6000} />
      <div className={`registration-modal ${openSearchDialog ? 'open' : ''}`}>
        <div className="registration-modal-content" style={{ top: (!isMobile ? '-17%' : '0%'), left: (!isMobile ? '30%' : '2.5%'), maxWidth: (!isMobile ? '500px' : '80%') }}>
          <span className="close" onClick={handleCloseSearchDialog}>&times;</span>
          <h2 style={{ margin: '6px', marginTop: '0px', paddingBottom: '2px' }}>Search Filters</h2>
          <form onSubmit={handleSearch}>
            {/* Start Date */}
            <label htmlFor="startDate" className="label">Start Date:</label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
              onClick={(e) => {
                e.target.blur();  // Force blur
                e.target.focus(); // Re-focus to trigger the date picker again
                e.target.showPicker(); // Show the picker when clicked
              }}
              style={{ cursor: 'pointer' }} // Add a pointer cursor for better UX
            />

            {/* End Date */}
            <label htmlFor="endDate" className="label">End Date:</label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
              onClick={(e) => {
                e.target.blur();  // Force blur
                e.target.focus(); // Re-focus to trigger the date picker again
                e.target.showPicker(); // Show the picker when clicked
              }}
              style={{ cursor: 'pointer' }} // Add a pointer cursor for better UX
            />

            {/* Group Name */}
            <label htmlFor="gname" className="label">Group Name:</label>
            <select
              id="gname"
              value={selectedGroup} // Ensure you're using the right state variable here
              onChange={(e) => {
                const selectedGroupId = e.target.value;
                const selectedGroupObj = groupids.find(group => group.therapyGroupId == selectedGroupId);
                setSelectedGroup(selectedGroupId);
                setSelectedGroupName(selectedGroupObj ? selectedGroupObj.therapyGroupName : '');
              }}
            >
              <option value="" disabled>Select Group</option>
              {groupids.map((group) => (
                <option key={group.therapyGroupId} value={group.therapyGroupId}>
                  {group.therapyGroupName}
                </option>
              ))}
            </select>

            <button type="submit">Submit</button>
          </form>
        </div>
      </div>

      <RegistrationModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} ismobile={!isMobile} dbname={params.accountId} groupId={groupId} absentStatus={absentStatus} sessionId={sessionId} therapyDate={sessionDateValue} lateReason={lateReason} addToGroup={addToGroup} />
    </div>
  );
};

export default GroupTherapyProcess;
